import { useEffect } from 'react';
import { initFormEnterNavigation } from 'utils/formEnterNavigation';

/** Глобально: Enter в инпуте → следующее поле. */
export default function FormEnterNavigation() {
  useEffect(() => initFormEnterNavigation(), []);
  return null;
}
